// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5e069fda","455":"74c168cf","977":"ee9e51e4"}[chunkId] + ".chunk.js";
};